import styled from 'styled-components';

import { theme } from '../../../../global';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const InputsContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 15px;
  color: ${theme.colors.font_dark};
`;

export const StyledInput = styled.input`
  width: 100px;
  height: 40px;
  border: 1px solid ${theme.colors.textfield_enabled};
  border-radius: 12px;
  padding: 12px;
  color: ${theme.colors.font_dark};

  font-size: 14px;
  font-weight: 500;
  text-transform: lowercase;
`;
